import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    (this.element as HTMLInputElement).indeterminate = true;
  }
}
